import { render } from "./studioCourseQb.vue?vue&type=template&id=6171bd69&scoped=true"
import script from "./studioCourseQb.vue?vue&type=script&lang=js"
export * from "./studioCourseQb.vue?vue&type=script&lang=js"

import "./studioCourseQb.vue?vue&type=style&index=0&id=6171bd69&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6171bd69"]])

export default __exports__